function componentsRepositionCustomerPage() {
    hideOrderStatus();  
    initCustomerTypeSwitcher();
}

function hideOrderStatus() {
  var orderDate;
  var orderDateParagraph = $(".in-objednavky.customer-page #content .content-inner div > p:first-child");
  
  switch(lang) {
    case 'sk':
      orderDate = 'Dátum objednávky:';
      break;
    case 'hu':
      orderDate = 'Megrendelés dátuma:';
      orderDateParagraph = $(".in-rendelesek.customer-page #content .content-inner div > p:first-child");
      break;
    case 'cs':
      orderDate = 'Datum objednávky:';
      break;
    case 'ro':
      orderDate = 'Data comenzii:';
      orderDateParagraph = $(".in-comenzile-mele.customer-page #content .content-inner div > p:first-child");
      break;
    case 'bg':
      orderDate = 'Dátum objednávky:';
      break;
    case 'hr':
      orderDate = 'Datum narudžbe:';
      break;
    case 'sl':
      orderDate = 'Datum naročila:';
      break;
    case 'uk':
      orderDate = 'Dátum objednávky:';
      break;
    default:
    return;
  }

  if (orderDateParagraph.length > 0) {
    var contents = orderDateParagraph.contents();

    contents.each(function() {
      if (this.nodeType === 3 && $(this).text().trim().startsWith(orderDate)) {
        var wrappOrderDate = $('<span class="show-order-date">' + $(this).text().trim() + '</span>');
        $(this).replaceWith(wrappOrderDate);
        wrappOrderDate.parent().addClass('hide-element-order-status');

        return false;
        }
    });
  }
}

function initCustomerTypeSwitcher() {
  const retail = document.querySelector('#retail');
  const wholesale = document.querySelector('#velkoobchodny-odberatel');

  if (!retail || !wholesale) return;

  const parentRetail = retail.closest('.form-group');
  const parentWholesale = wholesale.closest('.form-group');

  if (!parentRetail || !parentWholesale) return;

  // Create wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'customer-type-switcher';

  // Insert and wrap
  parentRetail.parentNode.insertBefore(wrapper, parentRetail);
  wrapper.appendChild(parentRetail);
  wrapper.appendChild(parentWholesale);

  function updateSwitcher() {
    wrapper.classList.toggle('retail-active', retail.checked);
    wrapper.classList.toggle('wholesale-active', wholesale.checked);
  }

  // Initial state + listeners
  updateSwitcher();
  retail.addEventListener('change', updateSwitcher);
  wholesale.addEventListener('change', updateSwitcher);
}

